var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "filter-form",
      attrs: { model: _vm.filters, "label-position": "top" }
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "Search" } },
        [
          _c("el-input", {
            directives: [
              {
                name: "debounce",
                rawName: "v-debounce",
                value: _vm.doFilter,
                expression: "doFilter"
              }
            ],
            staticClass: "search-input",
            model: {
              value: _vm.filters.q,
              callback: function($$v) {
                _vm.$set(_vm.filters, "q", $$v)
              },
              expression: "filters.q"
            }
          })
        ],
        1
      ),
      _vm.isFiltersChanged
        ? _c(
            "el-button",
            { attrs: { type: "gray" }, on: { click: _vm.clearFilters } },
            [_vm._v(" Reset filters ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }